import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'trackify-unauthorized-page',
  templateUrl: './unauthorized-page.component.html',
  styleUrls: ['./unauthorized-page.component.scss']
})
export class UnauthorizedPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
